import HeatmapVisualization from "views/components/visualizations/heatmap/HeatmapVisualization";
import HeatmapVisualizationConfig, {
  COLORSCALES
} from "views/logic/aggregationbuilder/visualizations/HeatmapVisualizationConfig";
import { defaultCompare } from "logic/DefaultCompare";
import {
  areAtLeastNGroupingsConfigured,
  areAtLeastNMetricsConfigured
} from "views/components/visualizations/validations";
const validate = (formValues) => {
  const errors = [];
  if (!areAtLeastNGroupingsConfigured(formValues, 2)) {
    errors.push("Heatmap requires at least two groupings.");
  } else {
    const groupingDirections = formValues.groupBy.groupings.map((grouping) => grouping.direction);
    if (!groupingDirections.includes("row") || !groupingDirections.includes("column")) {
      errors.push("Groupings must include row and column groupings.");
    }
  }
  if (!areAtLeastNMetricsConfigured(formValues, 1)) {
    errors.push("At least one metric must be configured.");
  }
  return errors.length > 0 ? { type: errors.join(" ") } : {};
};
const heatmap = {
  type: HeatmapVisualization.type,
  displayName: "Heatmap",
  component: HeatmapVisualization,
  config: {
    fromConfig: ({
      autoScale,
      colorScale,
      reverseScale,
      defaultValue,
      useSmallestAsDefault,
      zMax,
      zMin
    } = HeatmapVisualizationConfig.empty()) => ({
      autoScale,
      colorScale,
      reverseScale,
      defaultValue,
      useSmallestAsDefault,
      zMax,
      zMin
    }),
    toConfig: ({
      autoScale = false,
      colorScale,
      reverseScale = false,
      useSmallestAsDefault,
      zMax,
      zMin,
      defaultValue
    }) => {
      const [finalZMin, finalZMax] = autoScale ? [void 0, void 0] : [zMin, zMax];
      return HeatmapVisualizationConfig.create(
        colorScale,
        reverseScale,
        autoScale,
        finalZMin,
        finalZMax,
        useSmallestAsDefault,
        defaultValue
      );
    },
    createConfig: () => ({ colorScale: "Viridis", autoScale: true }),
    fields: [
      {
        name: "colorScale",
        title: "Color Scale",
        required: true,
        type: "select",
        options: [...COLORSCALES].sort(defaultCompare)
      },
      {
        name: "reverseScale",
        type: "boolean",
        title: "Reverse Scale"
      },
      {
        name: "autoScale",
        type: "boolean",
        title: "Auto Scale"
      },
      {
        name: "zMin",
        type: "numeric",
        title: "Min",
        required: true,
        isShown: (values) => !(values == null ? void 0 : values.autoScale)
      },
      {
        name: "zMax",
        type: "numeric",
        title: "Max",
        required: true,
        isShown: (values) => !(values == null ? void 0 : values.autoScale)
      },
      {
        name: "useSmallestAsDefault",
        type: "boolean",
        title: "Use smallest as default"
      },
      {
        name: "defaultValue",
        type: "numeric",
        title: "Default Value",
        isShown: (values) => !(values == null ? void 0 : values.useSmallestAsDefault),
        required: false
      }
    ]
  },
  validate
};
export default heatmap;
